import { Component, Input, OnInit } from '@angular/core';
import { FeatureToggleService } from 'src/app/core/toggle/feature-toggle.service';
import { ProductAttribute } from '../../models/attributes.model';
import { ProductCard } from '../../models/product-card.model';

@Component({
  selector: 'lps-card-product',
  templateUrl: './card-product.component.html',
  styleUrls: ['./card-product.component.scss']
})
export class CardProductComponent implements OnInit {

  @Input() productCard: ProductCard;
  @Input() displayRealtorContactLink: boolean;
  @Input() theme: string;
  @Input() target: string;
  @Input() productBaseLink: string;
  @Input() gridName: string;
  @Input() hideBookmark?: boolean;
  @Input() showGrid3Cols?: boolean;
  @Input() showSwiper = false;
  @Input() nickname: string;

  photo: any;
  campaign: string;
  attributes: ProductAttribute[];

  constructor(
    private readonly featureToggleService: FeatureToggleService
  ) { }

  stopPropagation(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  ngOnInit() {
    this.setPhoto();
    this.setAttributes();
  }

  showCarousel() {
    if (this.showSwiper) {
      return this.featureToggleService.isActive('toggle_show_card_grid_carousel');
    } else {
      return this.showSwiper;
    }
  }

  setPhoto() {
    const existPhoto = this.productCard && this.productCard.photo && this.productCard.photo[0] ? this.productCard.photo[0] : null;
    if (this.featureToggleService.isActive('toggle_show_alt_in_product_image')) {
      this.photo = {
        src: existPhoto ? existPhoto.smallUrl : '',
        name: existPhoto && this.productCard ? this.productCard.imageAlternateText : ''
      };
    } else {
      this.photo = {
        src: existPhoto ? existPhoto.smallUrl : '',
        name: existPhoto ? existPhoto.name : '',
      };
    }
  }

  setAttributes() {
    if (!this.productCard || !this.productCard.attributes) {
      return;
    }
    this.attributes = this.productCard.attributes;
  }

}
